<template>
	<div class="mb-gapx2">
		<div class="file-uploader-header align-items-center">
			<div class="absolute floating-icon" v-if="loaded">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.7034 10.7108C17.096 10.3223 17.0993 9.68917 16.7108 9.29661C16.3223 8.90404 15.6892 8.90073 15.2966 9.2892L10.9402 13.6003L8.69603 11.4248C8.29948 11.0404 7.6664 11.0503 7.28199 11.4468C6.89758 11.8434 6.90742 12.4765 7.30397 12.8609L10.2513 15.718C10.6421 16.0968 11.264 16.0936 11.6508 15.7108L16.7034 10.7108Z"/>
				</svg>
			</div>
			<FormLabel :label="index+'. '+label" :type="loaded?'primary':'secondary'" :has_error="loaded_error" :error_text="$t('message.ng_register.required_file')"/>
			<input type="file" @change="handleFileSelected" ref="file" class="hidden">
			<ButtonLink :label="$t('message.ng_register.uploading')" v-if="loading" :disabled="true">
				<template v-slot:icon>
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor" class="spinning">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C10.3524 4 8.82317 4.48589 7.54686 5.31955C7.08447 5.62157 6.4648 5.49157 6.16278 5.02918C5.86075 4.56679 5.99075 3.94712 6.45314 3.6451C8.04574 2.60484 9.9534 2 12 2C14.0466 2 15.9543 2.60484 17.5469 3.6451C18.0092 3.94712 18.1392 4.56679 17.8372 5.02918C17.5352 5.49157 16.9155 5.62157 16.4531 5.31955C15.1768 4.48589 13.6476 4 12 4ZM5.02918 6.16278C5.49157 6.4648 5.62157 7.08447 5.31955 7.54686C4.48589 8.82317 4 10.3524 4 12C4 13.6476 4.48589 15.1768 5.31955 16.4531C5.62157 16.9155 5.49157 17.5352 5.02918 17.8372C4.56679 18.1392 3.94712 18.0092 3.6451 17.5469C2.60484 15.9543 2 14.0466 2 12C2 9.9534 2.60484 8.04574 3.6451 6.45314C3.94712 5.99075 4.56679 5.86075 5.02918 6.16278ZM18.9708 6.16278C19.4332 5.86075 20.0529 5.99075 20.3549 6.45314C21.3952 8.04574 22 9.9534 22 12C22 14.0466 21.3952 15.9543 20.3549 17.5469C20.0529 18.0092 19.4332 18.1392 18.9708 17.8372C18.5084 17.5352 18.3784 16.9155 18.6805 16.4531C19.5141 15.1768 20 13.6476 20 12C20 10.3524 19.5141 8.82317 18.6805 7.54686C18.3784 7.08447 18.5084 6.4648 18.9708 6.16278ZM6.16278 18.9708C6.4648 18.5084 7.08447 18.3784 7.54686 18.6805C8.82317 19.5141 10.3524 20 12 20C13.6476 20 15.1768 19.5141 16.4531 18.6805C16.9155 18.3784 17.5352 18.5084 17.8372 18.9708C18.1392 19.4332 18.0092 20.0529 17.5469 20.3549C15.9543 21.3952 14.0466 22 12 22C9.9534 22 8.04574 21.3952 6.45314 20.3549C5.99075 20.0529 5.86075 19.4332 6.16278 18.9708Z"/>
					</svg>
				</template>		
			</ButtonLink>
			<ButtonLink :label="$t('message.ng_register.upload')" @click="triggerFile" v-if="!loading" :disabled="loaded && !multiple">
				<template v-slot:icon>
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M8.81125 2.33872C9.36521 2.11486 9.95849 2 10.557 2C11.1554 2 11.7487 2.11486 12.3027 2.33872C12.8567 2.56259 13.3614 2.89146 13.7867 3.30787C14.2121 3.72436 14.5496 4.22022 14.778 4.76761C15.0057 5.31315 15.1199 5.89802 15.1134 6.48823L15.1066 16.038L15.1065 16.0458C15.0933 16.8516 14.7529 17.6131 14.1701 18.168C13.5883 18.7219 12.8115 19.0269 12.0086 19.0269C11.2058 19.0269 10.429 18.7219 9.8472 18.168C9.26435 17.6131 8.92398 16.8516 8.91082 16.0458L8.91069 16.0376V8.74541C8.91069 8.19312 9.35841 7.74541 9.91069 7.74541C10.463 7.74541 10.9107 8.19312 10.9107 8.74541V16.0198C10.9167 16.2769 11.0259 16.5287 11.2263 16.7195C11.4295 16.913 11.71 17.0269 12.0086 17.0269C12.3073 17.0269 12.5878 16.913 12.791 16.7195C12.9915 16.5286 13.1007 16.2767 13.1066 16.0195L13.1134 6.46942C13.1174 6.15125 13.0562 5.83469 12.9323 5.53776C12.8084 5.24075 12.6238 4.96826 12.3875 4.73697C12.1512 4.50561 11.868 4.32018 11.5533 4.19304C11.2387 4.06588 10.8999 4 10.557 4C10.214 4 9.87525 4.06588 9.56057 4.19304C9.24593 4.32018 8.96268 4.50561 8.72637 4.73697C8.49013 4.96826 8.30556 5.24075 8.18163 5.53776C8.05774 5.83469 7.99645 6.15125 8.00044 6.46942L8.0006 6.48197L8.00052 16.1012L8.00041 16.1087C7.99288 16.6124 8.08887 17.1132 8.28368 17.5825C8.47853 18.0518 8.76882 18.4813 9.1394 18.8449C9.51005 19.2087 9.95358 19.4993 10.4451 19.6982C10.9366 19.8971 11.4653 20 12 20C12.5347 20 13.0634 19.8971 13.5549 19.6982C14.0464 19.4993 14.4899 19.2087 14.8606 18.8449C15.2312 18.4813 15.5215 18.0518 15.7163 17.5825C15.9111 17.1132 16.0071 16.6124 15.9996 16.1087L15.9995 16.1012V7.11188C15.9995 6.5596 16.4472 6.11188 16.9995 6.11188C17.5518 6.11188 17.9995 6.5596 17.9995 7.11188V16.0867C18.01 16.8622 17.8615 17.6313 17.5635 18.3493C17.2644 19.0696 16.8213 19.723 16.2614 20.2724C15.7017 20.8217 15.0365 21.2561 14.3053 21.5521C13.5742 21.848 12.7907 22 12 22C11.2093 22 10.4258 21.848 9.6947 21.5521C8.96352 21.2561 8.2983 20.8217 7.73856 20.2724C7.17874 19.723 6.73557 19.0696 6.43653 18.3493C6.13847 17.6313 5.98999 16.8622 6.00052 16.0866V6.48783C5.99403 5.89776 6.10829 5.31302 6.33587 4.76761C6.56427 4.22021 6.90181 3.72435 7.3272 3.30787C7.75251 2.89146 8.25724 2.56259 8.81125 2.33872Z"/>
					</svg>
				</template>
			</ButtonLink>
		</div>
		<template v-for="(document, document_index) in documents">
			<div class="grid-2-cols gap-md align-items-center" v-if="loaded && document.file_id!==''">
				<div>
					{{	document.file_name }}
				</div>
				<div class="text-right">
					<ButtonLinkSecondary @click="removeDocument(document_index)">
						<template v-slot:icon>
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M10 3C10 2.44772 10.4477 2 11 2H13C13.5523 2 14 2.44772 14 3V4H19C19.5523 4 20 4.44772 20 5C20 5.55228 19.5523 6 19 6H5C4.44772 6 4 5.55228 4 5C4 4.44772 4.44772 4 5 4H10V3ZM10 18C9.44772 18 9 17.5523 9 17L9 9C9 8.44772 9.44772 8 10 8C10.5523 8 11 8.44771 11 9V17C11 17.5523 10.5523 18 10 18ZM13 17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V9C15 8.44771 14.5523 8 14 8C13.4477 8 13 8.44772 13 9V17ZM7 9C7 8.44772 6.55228 8 6 8C5.44772 8 5 8.44772 5 9V18C5 20.2091 6.79086 22 9 22H15C17.2091 22 19 20.2091 19 18V9C19 8.44772 18.5523 8 18 8C17.4477 8 17 8.44772 17 9V18C17 19.1046 16.1046 20 15 20H9C7.89543 20 7 19.1046 7 18V9Z"/>
						</svg>
						</template>
					</ButtonLinkSecondary>
				</div>
			</div>
			<div class="grid-2-cols gap-md">
				<TextInput v-model="document.reference_number" :placeholder="$t('message.ng_register.reference_number')" :has_error="document.reference_error" />
				<DateInput v-model="document.date" :placeholder="$t('message.ng_register.document_date')" :has_error="document.date_error" />
			</div>
		</template>
	</div>
</template>
<script>
	import {TextInput, DateInput, FormLabel, ButtonLink, ButtonLinkSecondary} from './../simplements'
	export default {
		name: 'NCSRegFileUploader',
		components: {
			TextInput, DateInput, FormLabel, ButtonLink, ButtonLinkSecondary
		},
		props: {
			type: {
				type: String,
			},
			label: {
				type: String,
			},
			multiple: {
				type: Boolean
			},
			index: {
				type: [String, Number]
			},
			loaded_error: {
				type: Boolean,
				default: false
			},
			document_errors: {
				type: Array
			}
		},
		data(){
			return {

				documents: [
					{
						date: '',
						reference_number: '',
						file_name: '',
						file_id: '',
						date_error: false,
						reference_error: false,
					}
				],

				file: null,

				loading: false,
				loaded: false,
			}
		},
		methods: {
			validate(){
				this.documents.forEach((item, index)=>{
					if(item.date=='')
						this.$set(this.documents[index], 'date_error', true)
					else
						this.$set(this.documents[index], 'date_error', false)
					if(item.reference_number=='')
						this.$set(this.documents[index], 'reference_error', true)
					else
						this.$set(this.documents[index], 'reference_error', false)
				})
			},
			removeDocument(index){
				this.documents.splice(index, 1)
				if(this.documents.length == 0){
					this.loaded = false
					this.documents.push({
						reference_number: '',
						date: '',
						file_name: '',
						file_id: ''
					})
				}
				this.$emit('update', {loaded: this.loaded, documents: this.documents})
			},
			handleFileSelected(event){
				this.file = event.target.files[0]
				if(this.file){
					let fd = new FormData
					fd.append('docid', 0)
					fd.append('type', '')
					fd.append('file', this.file)
					this.loading = true
					axios.post(window.base + '/document/uploadfile', fd).then(response=>{
						if(this.loaded && this.multiple){
							this.documents.push({
								reference_number: '',
								date: '',
								file_id: '',
								file_name: ''
							})
						}
						this.documents[this.documents.length-1].file_id = response.data.ID
						this.documents[this.documents.length-1].file_name = response.data.Name
						this.loading = false
						this.loaded = true

						this.$emit('update', {loaded: this.loaded, documents: this.documents})
					})
				}
			},
			triggerFile(){
				this.$refs.file.click()
			}
		}
	}
</script>
<style scoped>
	@import url('./../simplements/assets/basic.css');

	.file-uploader-header{
		display: flex;
		justify-content: space-between;
	}

	.floating-icon{
		color: var(--primary);
		transform: translateX(calc(-100% - var(--gap-sm)));
	}
</style>